import React, { useEffect, useState } from 'react';
// material
import { Box, Grid, Container, Typography } from '@mui/material';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
// components
import Page from '../components/Page';
import {
  AppTasks,
  AppNewUsers,
  AppBugReports,
  AppItemOrders,
  AppNewsUpdate,
  AppWeeklySales,
  AppOrderTimeline,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppTrafficBySite,
  AppCurrentSubject,
  AppConversionRates
} from '../components/_dashboard/app';

// ----------------------------------------------------------------------

export default function DashboardApp() {
  const color1 = '#FFE7D9';
  const color2 = '#FFF7CD';
  const [t, i18n] = useTranslation();
  const [dashboard, setDashboard] = useState([]);
  const userDetails = JSON.parse(localStorage.getItem('user'));
  const TOTAL = 714000;

  // GET Dashboard
  const getDashboard = async () => {
    const token = localStorage.getItem('access');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    const response = await axios({
      method: 'get',
      url: `${API_ENDPOINT}/api/dashboard`,
      headers: { Authorization: `Bearer ${token}` }
    });
    if (response.data) {
      setDashboard(response.data);
    }
    console.log('dashboard==>', response.data);
  };

  useEffect(() => {
    getDashboard();
  }, []);

  return (
    <Page title="Dashboard">
      <Container maxWidth="xl">
        {userDetails.is_admin && (
          <>
            <Box sx={{ pb: 5 }}>
              <Typography variant="h4">{t('Dashboardadmin')}</Typography>
            </Box>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box sx={{ pb: 5 }}>
                  <Typography variant="h4" align="center">
                    {t('statistiquesgénérale')}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_parents}
                  title={t('nbr_parents')}
                  bg={color1}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_children}
                  title={t('nbr_children')}
                  bg={color1}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_active_children}
                  title={t('nbr_active_children')}
                  bg={color1}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_educators}
                  title={t('nbr_educators')}
                  bg={color1}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales total={dashboard.nbr_posts} title={t('nbr_posts')} bg={color1} />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_posts_today}
                  title={t('nbr_posts_today')}
                  bg={color1}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_story_total}
                  title={t('nbr_story_total')}
                  bg={color1}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_story_today}
                  title={t('nbr_story_today')}
                  bg={color1}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_activity_total_today}
                  title={t('nbr_activity_total_today')}
                  bg={color1}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: 10 }}>
              <Grid item xs={12}>
                <Box sx={{ pb: 5 }}>
                  <Typography variant="h4" align="center">
                    {t('statistiquespaiements')}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.payment_validated_by_admin}
                  title={t('payment-validated-by-admin')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.total_payment_validated_by_admin}
                  title={t('total-payment-validated-by-admin')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.total_payment_validated_by_admin_this_month}
                  title={t('total-payment-validated-by-admin-this-month')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.payment_requested_by_creche}
                  title={t('payment-requested-by-creche')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.payment_validated_by_commercials}
                  title={t('payment-validated-by-commercials')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.total_payment_validated_by_commercials}
                  title={t('total_payment_validated_by_commercials')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.total_payment_validated_by_commercials_this_month}
                  title={t('total_payment_validated_by_commercials_this_month')}
                  bg={color2}
                />
              </Grid>
            </Grid>
          </>
        )}
        {userDetails.is_commercial && (
          <>
            <Box sx={{ pb: 5 }}>
              <Typography variant="h4">{t('Dashboardcommercial')}</Typography>
            </Box>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box sx={{ pb: 5 }}>
                  <Typography variant="h4" align="center">
                    {t('statistiquesgénérale')}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_active_children}
                  title={t('nbr_active_children')}
                  bg={color1}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_educators}
                  title={t('nbr_educators')}
                  bg={color1}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_creches_by_commercial}
                  title={t('nbr_creches_by_commercial')}
                  bg={color1}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_class_total}
                  title={t('nbr_class_total')}
                  bg={color1}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_activity_total_today}
                  title={t('nbr_activity_total_today')}
                  bg={color1}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: 10 }}>
              <Grid item xs={12}>
                <Box sx={{ pb: 5 }}>
                  <Typography variant="h4" align="center">
                    {t('statistiquespaiements')}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.payment_validated_by_admin}
                  title={t('payment-validated-by-admin')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.total_payment_validated_by_admin}
                  title={t('total-payment-validated-by-admin')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.total_payment_validated_by_admin_this_month}
                  title={t('total-payment-validated-by-admin-this-month')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.payment_requested_by_creche}
                  title={t('payment-requested-by-creche')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.payment_validated_by_commercials}
                  title={t('payment-validated-by-commercials')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.total_payment_validated_by_commercials}
                  title={t('total_payment_validated_by_commercials')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.total_payment_validated_by_commercials_this_month}
                  title={t('total_payment_validated_by_commercials_this_month')}
                  bg={color2}
                />
              </Grid>
            </Grid>
          </>
        )}
        {userDetails.is_creche && (
          <>
            <Box sx={{ pb: 5 }}>
              <Typography variant="h4">{t('Dashboardcreche')}</Typography>
            </Box>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box sx={{ pb: 5 }}>
                  <Typography variant="h4" align="center">
                    {t('statistiquesgénérale')}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_class_total}
                  title={t('nbr_class_total')}
                  bg={color1}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_children_total}
                  title={t('nbr_children')}
                  bg={color1}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_active_children}
                  title={t('nbr_active_children')}
                  bg={color1}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_educators}
                  title={t('nbr_educators')}
                  bg={color1}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_story_total}
                  title={t('nbr_story_total')}
                  bg={color1}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_story_today}
                  title={t('nbr_story_today')}
                  bg={color1}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.nbr_activity_total_today}
                  title={t('nbr_activity_total_today')}
                  bg={color1}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: 10 }}>
              <Grid item xs={12}>
                <Box sx={{ pb: 5 }}>
                  <Typography variant="h4" align="center">
                    {t('statistiquespaiements')}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.payment_validated_by_admin}
                  title={t('payment-validated-by-admin')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.total_payment_validated_by_admin}
                  title={t('total-payment-validated-by-admin')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.total_payment_validated_by_admin_this_month}
                  title={t('total-payment-validated-by-admin-this-month')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.payment_requested_by_creche}
                  title={t('payment-requested-by-creche')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.payment_requested_by_creche_this_month}
                  title={t('payment_requested_by_creche_this_month')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.payment_validated_by_commercials}
                  title={t('payment-validated-by-commercials')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.total_payment_validated_by_commercials}
                  title={t('total_payment_validated_by_commercials')}
                  bg={color2}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <AppWeeklySales
                  total={dashboard.total_payment_validated_by_commercials_this_month}
                  title={t('total_payment_validated_by_commercials_this_month')}
                  bg={color2}
                />
              </Grid>
            </Grid>
          </>
        )}
      </Container>
    </Page>
  );
}

/* <Grid item xs={12} md={6} lg={8}>
            <AppWebsiteVisits />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppCurrentVisits />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppConversionRates />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppCurrentSubject />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppNewsUpdate />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppOrderTimeline />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppTrafficBySite />
          </Grid>

          <Grid item xs={12} md={6} lg={8}>
            <AppTasks />
          </Grid>
          */
